import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable, of} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {ErrorService, EventService} from '..';
import {UserResponse, User, UserRole, UserApiKey} from '../models/user';
import { ConfigService } from './config.service';


@Injectable({providedIn: 'root'})
export class UserService {

    private userUrl = ConfigService.getApiEndpoint() + 'v1/user/';
    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    search(query: any): Observable<UserResponse> {
        return this.http.get<UserResponse>(this.userUrl + 'search', { params: query }).pipe(
            catchError(this.error.handleError('user.search', null))
        );
    }


    getAll(): Observable<User[]> {
        return this.http.get<User[]>(this.userUrl).pipe(
            catchError(this.error.handleError('user.getAll', null))
        );
    }

    getAvailableRoles(): Observable<UserRole[]> {
        return this.http.get<UserRole[]>(this.userUrl + 'roles').pipe(
            catchError(this.error.handleError('user.getAvailableRoles', null))
        );
    }

    getOne(id: string): Observable<User> {
        return this.http.get<User>(this.userUrl + id).pipe(
            catchError(this.error.handleError('user.getOne', null))
        );
    }

    create(user: User): Observable<User> {
        return this.http.post<User>(this.userUrl, user).pipe(
            tap(_ => this.eventService.addAlert(`created user ${user.name}`)),
            catchError(
                // console.log('asd')
                this.error.handleError('User creation failed', null)
            )
        );
    }

    update(user: User): Observable<User> {
        return this.http.put<User>(this.userUrl + user.id, user).pipe(
            tap(_ => this.eventService.addAlert(`updated user: ${user.name}`)),
            catchError(this.error.handleError('User update failed', null))
        );
    }

    delete(id: String): Observable<User> {
        return this.http.delete<User>(this.userUrl + id).pipe(
            catchError(this.error.handleError('user.delete', null))
        );
    }

    getApiKey(userId: string): Observable<UserApiKey> {
      return this.http.get<UserApiKey>(this.userUrl + userId + '/apikey').pipe(
        catchError(this.error.handleError('user.getApiKey', null))
      );
    }

    resetApiKey(userId: string): Observable<UserApiKey> {
      return this.http.put<UserApiKey>(this.userUrl + userId + '/apikey', null).pipe(
        tap(_ => this.eventService.addAlert(`updated api key`)),
        catchError(this.error.handleError('user.getApiKey', null))
      );
    }

}
